import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"

const BordAddandEditDialogComponent = ({ openDialog, handleCloseDialog, addDialogLoading, handleSubmit, editData, formData, setFormData }: any) => {
    return (
        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                {editData ? 'Edit Board Name' : 'Add New Board Name'}
            </DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <TextField
                        fullWidth
                        label="Name"
                        value={formData.name}
                        onChange={e => setFormData({ ...formData, name: e.target.value })}
                        required
                        placeholder="Enter Name"
                        autoComplete="off"
                    />
                    <TextField
                        fullWidth
                        label="Description"
                        value={formData.description}
                        onChange={e => setFormData({ ...formData, description: e.target.value })}
                        required
                        placeholder="Enter Description"
                        rows={4}
                        multiline
                        autoComplete="off"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} disabled={addDialogLoading}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={addDialogLoading}
                    sx={{ bgcolor: '#5BC0BE', '&:hover': { bgcolor: '#49a9a7' } }}
                >
                    {addDialogLoading ? 'Submitting...' : editData ? 'Update' : 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default BordAddandEditDialogComponent
